/**
 * GalleryGridView
 *
 * Kachelansicht für die Gallery. Uses container queries for responsive
 * column count that adapts to available width (not viewport).
 */

import { GalleryImageCard } from '../cards/GalleryImageCard';
import type { GalleryImage } from '@/lib/api/gallery-v2';

interface GalleryGridViewProps {
  images: GalleryImage[];
  selectedIds: Set<string>;
  onToggleSelect: (id: string) => void;
  onToggleFavorite: (id: string) => void;
  onImageClick?: (image: GalleryImage) => void;
  showApprovalActions?: boolean;
  columns?: 4 | 5;
}

export function GalleryGridView({
  images,
  selectedIds,
  onToggleSelect,
  onToggleFavorite,
  onImageClick,
  showApprovalActions = false,
  columns = 4,
}: GalleryGridViewProps) {
  const gridClass =
    columns === 5
      ? 'grid grid-cols-2 @[400px]:grid-cols-3 @[700px]:grid-cols-4 @[1000px]:grid-cols-5 gap-3'
      : 'grid grid-cols-2 @[400px]:grid-cols-3 @[700px]:grid-cols-4 gap-4';

  return (
    <div className="@container">
      <div className={gridClass}>
        {images.map((image) => (
          <GalleryImageCard
            key={image.id}
            image={image}
            isSelected={selectedIds.has(image.id)}
            onToggleSelect={() => onToggleSelect(image.id)}
            onToggleFavorite={() => onToggleFavorite(image.id)}
            onClick={() => onImageClick?.(image)}
            variant="grid"
            showApprovalActions={showApprovalActions}
          />
        ))}
      </div>
    </div>
  );
}
